import { SB } from '@play-co/replicant';
import { getPetAssetKey, speciesChatbot } from './species';
import { createFlexMessageTemplate, createFlexContainer } from './utils';
import { FlexComponent } from './types';
import { buildSender } from '../sender';

/**
 * Format used for the reply flex message
 */
export type ReplyFlexMessageData = {
  message: string;
  selectedIndex: number;
} & {
  [key: string]: unknown;
};

/**
 * Create daycare message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const replyFlexMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    petName: SB.string(),
    message: SB.string(),
    select: SB.array(SB.string()),
  }),
  (data, payload, api) => {
    const altText = data.message;
    const normal = api.getAssetPath(getPetAssetKey(data.species));

    const options = data.select.map((answer, index) => ({
      type: 'button',
      style: 'primary',
      height: 'sm',
      action: {
        type: 'postback',
        label: answer,
        data: JSON.stringify({
          $key: payload.$key,
          feature: payload.feature,
          $subFeature: payload.$subFeature,
          selectedIndex: index,
          message: data.message,
        } as ReplyFlexMessageData),
        displayText: answer,
        inputOption: 'openKeyboard',
      },
    }));

    const template = createFlexContainer(altText, {
      type: 'bubble',
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'text',
            text: data.message,
            size: 'md',
            wrap: true,
          },
        ],
        backgroundColor: '#ECECEC',
      },
      footer: {
        type: 'box',
        layout: 'vertical',
        spacing: 'sm',
        contents: options as FlexComponent[],
        flex: 0,
      },
    });

    // Add sender to message
    template['sender'] = buildSender({ name: data.petName, iconUrl: normal });

    return template;
  },
);
